<template>
    <ui-alert :type="type" :dismissible="false">
        <span v-if="!isLoading">{{ availability }} {{ availability === 1 ? 'car' : 'cars' }} available for these dates</span>
        <span v-else>Getting availability...</span>
    </ui-alert>
</template>

<script>
    import {CourtesyCarReservationResource} from "../../classes/Api/CourtesyCarReservation";
    import { debounce } from 'lodash'
    import Moment from 'moment'

    export default {
        props: {
            from: {
                type: Object,
                required: true,
            },
            to: {
                type: Object,
                required: true,
            },
            requiresAutomatic: {
                type: Boolean,
                default: false,
            },
            currentBookingId: {
                type: Number,
                default: 0,
            }
        },
        watch: {
            from() {
                this.updateAvailability()
            },
            to() {
                this.updateAvailability()
            },
            requiresAutomatic() {
                this.updateAvailability()
            }
        },
        mounted() {
            this.updateAvailability()
        },
        data() {
            return {
                availability: 0,
                isLoading: false,
            }
        },
        computed: {
            type() {
                if (this.availability > 2) {
                    return 'success'
                } else if (this.availability > 0) {
                    return 'warning'
                }

                return 'error'
            }
        },
        methods: {
            updateAvailability: debounce(function() {
                this.isLoading = true

                let params = {
                    from: new Moment(this.from).tz('UTC').format(),
                    to: new Moment(this.to).tz('UTC').format(),
                    requires_automatic: this.requiresAutomatic ? '1' : '0',
                    exclude_booking_id: this.currentBookingId ? this.currentBookingId : '0'
                }

                CourtesyCarReservationResource.availability(params).then(r => {
                    this.availability = r.data.availability

                    this.$emit('updated', this.availability)

                    this.isLoading = false
                }).catch(e => { handleApiError(e); this.isLoading = false; })
            }, 100)
        }
    }
</script>

<style scoped>

</style>